/**
 * Facebook script version: NO_SCRIPT
 * Google script version: V_5
 */

(function() {
    var facebookRemarketingActive = JSON.parse('false'); /* boolean true/false */
    var googleRemarketingActive = JSON.parse('true'); /* boolean true/false */

    // see initialization of this object in liquid/roi_hunter_easy_head_snippet.liquid
    var objectHash = 'ROIHunterEasy_5a83c915b9f3150f071dd42973557062ac2f30b295a5b6393544410da07ecb27';
    var ourAmazingGlobalObject = window[objectHash];
    if (typeof ourAmazingGlobalObject === 'undefined') {
        return;
    }

    if (facebookRemarketingActive) { // if customer has active facebook

        ourAmazingGlobalObject.rheasy_fbq('', 'PageView');

        var eventName;
        if (ourAmazingGlobalObject.cartPage.active) {
            googleParams = ourAmazingGlobalObject.cartPage.facebookEventParams;
            eventName = 'AddToCart';
            ourAmazingGlobalObject.rheasy_fbq('', eventName, ourAmazingGlobalObject.cartPage.facebookEventParams);
        } else if (ourAmazingGlobalObject.productPage.active) {
            googleParams = ourAmazingGlobalObject.productPage.facebookEventParams;
            eventName = 'ViewContent';
            ourAmazingGlobalObject.rheasy_fbq('', eventName, ourAmazingGlobalObject.cartPage.facebookEventParams);
        }
    }

    if (googleRemarketingActive) {
        var googleParams;
        if (ourAmazingGlobalObject.cartPage.active) {
            googleParams = ourAmazingGlobalObject.cartPage.googleTagParams;
        } else if (ourAmazingGlobalObject.productPage.active) {
            googleParams = ourAmazingGlobalObject.productPage.googleTagParams;
        } else if (ourAmazingGlobalObject.collectionPage.active) {
            googleParams = ourAmazingGlobalObject.collectionPage.googleTagParams;
        } else if (ourAmazingGlobalObject.mainPage.active) {
            googleParams = ourAmazingGlobalObject.mainPage.googleTagParams;
        } else {
            return;
        }

        ourAmazingGlobalObject.loadGoogleScript('https://www.googleadservices.com/pagead/conversion_async.js', function () {
            window.google_trackConversion({
                google_conversion_id: JSON.parse('1001701754'),
                google_custom_params: googleParams,
                google_remarketing_only: true
            })
        });
    }
})();